import { useCallback } from "react";

import { useProductRoomFormModelContext } from "../../../../context";

export const useRoomName = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();
	const { name } = viewModel;

	const onSetName = useCallback(
		(input: string) => {
			onSetViewModel([{ key: "name", value: { ...name, value: input } }]);
		},
		[name, onSetViewModel],
	);

	return {
		name,
		onSetName,
	};
};
